<template>
  <header class="header">
    <div class="header__container container">
      <a href="https://imast.am/" target="_blank" class="header__logo">
        <svgo-logo class="logo" aria-label="IMAST" />
      </a>

      <client-only>
        <TransitionGroup tag="div" name="fade-logout" class="header__controls">
          <Language key="language" />
          <Logout v-if="isAuth" key="logout" @logout="$emit('logout')" />
        </TransitionGroup>
      </client-only>
    </div>
  </header>
</template>

<script setup>
import useProfileStore from '~/store/profile';

defineEmits(['logout']);

const isAuth = computed(() => useProfileStore().isAuth);
</script>

<style lang="scss">
@use '@styles/components/layout/header.scss' as *;
</style>
